export default "__VITE_ASSET__da49105e__"